import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f7fa' },
  card: { background: '#fff', borderRadius: 12, padding: 40, width: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' },
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 6 },
  input: { width: '100%', padding: '10px 14px', fontSize: 14, border: '1px solid #ddd', borderRadius: 6, boxSizing: 'border-box', marginBottom: 16 },
  btn: { width: '100%', padding: '12px', background: '#7c83fd', color: '#fff', border: 'none', borderRadius: 6, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginBottom: 8 },
  errorBox: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '10px 14px', marginBottom: 16, color: '#dc2626', fontSize: 13 },
  successBox: { background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '10px 14px', marginBottom: 16, color: '#166534', fontSize: 13 },
  link: { color: '#7c83fd', textDecoration: 'none', fontWeight: 600 },
};

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState('email'); // email → otp → done
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const sendOtp = async () => {
    if (!email) { setError('Enter your email'); return; }
    setError(''); setLoading(true);
    try {
      await authApi.forgotPassword(email);
      setStep('otp');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset code');
    } finally { setLoading(false); }
  };

  const resetPassword = async () => {
    if (newPassword.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    setError(''); setLoading(true);
    try {
      await authApi.resetPassword(email, otp, newPassword);
      setStep('done');
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed. Check your code.');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>🔑</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1a1a2e', marginBottom: 4 }}>
          {step === 'done' ? 'Password Reset' : 'Forgot Password'}
        </h2>
        <p style={{ color: '#666', fontSize: 14, marginBottom: 24 }}>
          {step === 'email' && 'Enter your email to receive a reset code.'}
          {step === 'otp' && `Enter the 6-digit code sent to ${email} and your new password.`}
          {step === 'done' && 'Your password has been reset successfully.'}
        </p>

        {error && <div style={s.errorBox}>⚠️ {error}</div>}

        {step === 'email' && (
          <>
            <label style={s.label}>Email</label>
            <input style={s.input} type="email" placeholder="you@company.com"
              value={email} onChange={e => setEmail(e.target.value)} />
            <button style={s.btn} onClick={sendOtp} disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Code'}
            </button>
          </>
        )}

        {step === 'otp' && (
          <>
            <label style={s.label}>Reset Code</label>
            <input style={{ ...s.input, letterSpacing: 8, textAlign: 'center', fontSize: 20 }}
              maxLength={6} placeholder="000000"
              value={otp} onChange={e => setOtp(e.target.value)} />

            <label style={s.label}>New Password</label>
            <input style={s.input} type="password" placeholder="Min 8 characters"
              value={newPassword} onChange={e => setNewPassword(e.target.value)} />

            <label style={s.label}>Confirm New Password</label>
            <input style={s.input} type="password" placeholder="Repeat password"
              value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />

            <button style={s.btn} onClick={resetPassword} disabled={loading || otp.length !== 6}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
            <button style={{ ...s.btn, background: '#fff', color: '#666', border: '1px solid #ddd' }}
              onClick={() => { setStep('email'); setOtp(''); setError(''); }}>
              Back
            </button>
          </>
        )}

        {step === 'done' && (
          <>
            <div style={s.successBox}>✅ Password reset successfully. You can now sign in with your new password.</div>
            <button style={s.btn} onClick={() => navigate('/login')}>Go to Sign In</button>
          </>
        )}

        <div style={{ textAlign: 'center', fontSize: 13, color: '#666', marginTop: 16 }}>
          <Link to="/login" style={s.link}>← Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}
